module.exports = __webpack_public_path__ + "static/media/3DPPA18.c12872c6.jpg";